import { PhysicsLayers } from "../../../../../PhysicsLayers";
import { ParabolicProjectile } from "./abstract/ParabolicProjectile";

export class MoleProjectile extends ParabolicProjectile {
    public get collidesWithLayer(): number {
        return 1 << PhysicsLayers.Layer3;
    }
}
